import VirtualAudioGraph from './VirtualAudioGraph';
export * from './nodeFactories';
export { default as createNode } from './createNode';
export { default as createWorkletNode } from './createWorkletNode';
export default (function (config) {
  var audioContext = config && config.audioContext || new AudioContext();
  var output = config && config.output || audioContext.destination;
  return new VirtualAudioGraph(audioContext, output);
});